/**
 * Stages that are scheduled DIRECTLY in the TA Action Board — the Case interviews
 * panel and the Final rounds flow (final interviewer + bar raiser) — and therefore
 * must NOT be offered as a manual Interview Link. A booking link for one of these
 * would duplicate what the board already does and only confuse the recruiter.
 *
 * Matches Case Interview, Final Interview / Final round, and the final round's
 * Bar Raiser seat. First Interview and Personal Interview are the opening rounds
 * you DO create booking links for, so they never match.
 */
export function isBoardScheduledStage(stageName: string | null | undefined): boolean {
  const n = (stageName || '').toLowerCase();
  return /\b(case|final)\b/.test(n) || /bar[\s-]?raiser/.test(n);
}
